/**
 * Build-time configuration. Every VITE_* value is embedded in the public
 * bundle, so nothing here may be secret. See .env.example.
 */

const env = import.meta.env as ImportMetaEnv & Record<string, unknown>

function nonEmpty(value: unknown): string | undefined {
  return typeof value === 'string' && value.trim() !== '' ? value.trim() : undefined
}

export const config = {
  /** Catalog location, or "demo" to load the bundled sample catalog. */
  catalogUrl: nonEmpty(env.VITE_CATALOG_URL) ?? '/catalog.json',
  /** Base URL that relative game entry paths are resolved against. */
  gamesBaseUrl: nonEmpty(env.VITE_GAMES_BASE_URL),
} as const

/** Per-game build URL override: VITE_GAME_URL_<ID> (uppercase, dashes → underscores). */
export function gameUrlOverride(gameId: string): string | undefined {
  return nonEmpty(env[`VITE_GAME_URL_${gameId.toUpperCase().replace(/-/g, '_')}`])
}
